/**
 * created by lei lei
 *已采用媒体
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Col, Modal, Pagination, Popover, Radio, Row, Tabs,message} from "antd";
import {Scrollbars} from "react-custom-scrollbars";
import SpacerBlock from "../spacerBlock/SpacerBlock";
import web from './img/web.png';
import wechat from './img/wechat.png';
import microBlog from './img/microBlog.png';
import  tiktok from'./img/tiktok.png'
import *as actions from "../../../actions/manuscriptPool"

import source from './img/source.png';

export default class PublishedMedia extends Component {
    static defaultProps = {};
    static propTypes = {
        newSecondSelectColor: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.actions = actions;
        this.state = {
            mediaVisible: false,
            dataList: [],
            publishList: [],
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    publishMediaSow(list) {
        let dataList = [{
            title: '网站',
            img: web,
            child: []
        }, {
            title: '微信',
            img: wechat,
            child: []
        }, {
            title: '微博',
            img: microBlog,
            child: []
        }, {
            title: '抖音',
            img:tiktok ,
            child: []
        },];
        list.forEach(item => {
            let copyStorysList = item.copyStorys ? item.copyStorys : [];
            item.checked = false;
            if (copyStorysList.length > 0) {
                if (copyStorysList[0].statusName === '发布') {
                    item.statusName = '已发布';
                    item.publishId = copyStorysList[0].id;
                } else {
                    item.statusName = copyStorysList[0].statusName;
                    item.publishId = copyStorysList[0].id;
                }
                  copyStorysList.forEach(itemChild => {
                      if (itemChild.statusName === '发布') {
                          itemChild.statusName = '已发布';
                          item.publishId=itemChild.id;
                      }else{
                          itemChild.statusName = itemChild.statusName;
                          itemChild.publishId = itemChild.id;
                      }
                      itemChild={...item,...itemChild}
                      if (item.type === 1) {
                          dataList[0].child.push(itemChild)
                      } else if (item.type === 2) {
                          dataList[1].child.push(itemChild)
                      } else if (item.type === 3) {
                          dataList[2].child.push(itemChild)
                      }else if (item.type === 5) {
                          dataList[3].child.push(itemChild)
                      }
                  })
            }else{
                if (item.type === 1) {
                    dataList[0].child.push(item)
                } else if (item.type === 2) {
                    dataList[1].child.push(item)
                } else if (item.type === 3) {
                    dataList[2].child.push(item)
                }else if (item.type === 5) {
                    dataList[3].child.push(item)
                }
            }

        });

        this.setState({mediaVisible: true, dataList});
        setTimeout(() => {
            this.scrollRef && this.scrollRef.scrollToTop();
        });
    }

    render() {
        return (
            <div>
                <Modal
                    title={'已采用媒体'}
                    visible={this.state.mediaVisible}
                    onOk={() => {

                    }}
                    okText={'确认选择'}
                    cancelText={'取消关联'}
                    width={1000}
                    bodyStyle={{padding: 0}}
                    onCancel={() => {
                        this.setState({mediaVisible: false})
                    }}
                    footer={null}
                >
                    <div style={{height: '65vh', background: '#f4f6fc', padding: 20,}}>
                        <div style={{
                            height: "calc(65vh - 40px)",
                            background: '#ffffff',

                        }}>
                            <Scrollbars ref={(scrollRef) => {
                                this.scrollRef = scrollRef
                            }}>
                                {
                                    this.state.dataList.map((Item, i) => {
                                        return (
                                            <div key={i} style={{
                                                marginTop: i === 0 ? 30 : 0, paddingLeft: 30, paddingBottom: 30,
                                                paddingRight: 30
                                            }}>
                                                <div><img src={Item.img} alt=""/><span
                                                    style={{fontSize: 15, marginLeft: 20,color:'#727a8f'}}><b>{Item.title}</b></span>
                                                </div>
                                                <div style={{background: ' #f4f6fc', borderRadius: 6, marginTop: 20}}>
                                                    {
                                                        Item.child.map((item, index) => {
                                                            let title=item.name;
                                                            if(item.news&&item.news.length){
                                                                if(item.news.length>1){
                                                                    item.news.forEach(column=>{
                                                                       if(column.mainColumn===1){
                                                                           title=item.name+'——'+column.treeName+',...';
                                                                       }
                                                                    });
                                                                }else{
                                                                    title=item.name+'——'+item.news[0].treeName
                                                                }
                                                            }

                                                            return (

                                                                <Popover key={i + '' + index} content={<div
                                                                    style={{height: 100, overflow: 'auto'}}>
                                                                    {this.state.publishList.map((publishItem, publishIndex) => {
                                                                        return (
                                                                            <p style={{cursor: 'pointer'}}
                                                                               onClick={() => {
                                                                                   item.checked = false;
                                                                                   window.open(publishItem.url)
                                                                                   this.setState({})
                                                                               }}
                                                                               key={publishIndex}>{publishItem.column?publishItem.column:publishItem.url}</p>
                                                                        )
                                                                    })}

                                                                </div>}
                                                                         placement="bottom"
                                                                         title={null}
                                                                         onVisibleChange={() => {
                                                                             item.checked = false;
                                                                             this.setState({})
                                                                         }}
                                                                         visible={item.checked}>
                                                                    <div className={'item'}
                                                                         style={{
                                                                             border: 'solid 1px ' + this.props.newSecondSelectColor,
                                                                             float: 'left',
                                                                             /* width: 200,*/
                                                                             borderRadius: 6,
                                                                             padding: '12px 20px',
                                                                             textAlign: 'center',
                                                                             background: item.statusName === '已发布' ? this.props.newSecondSelectColor : '#ffffff',
                                                                             marginLeft: 20,
                                                                             marginTop: 20,
                                                                             cursor: 'pointer',
                                                                             fontSize: 15,
                                                                             color: item.statusName === '已发布' ? '#ffffff' : this.props.newSecondSelectColor,
                                                                             display:item.statusName === '已发布'? 'flex':'none',

                                                                         }} onClick={() => {
                                                                        if (item.statusName === '已发布') {
                                                                            this.state.dataList.forEach(parent=>{
                                                                                parent.child.forEach(child=>{
                                                                                    child.checked = false
                                                                                })
                                                                            });
                                                                           // this.state.dataList[i].child[index].checked = true;
                                                                            //item.checked=true;
                                                                            this.getOpenDetail(item);
                                                                        }
                                                                    }}>
                                                                        <div style={{
                                                                            /* width: 87,*/ overflow: 'hidden',
                                                                            textOverflow: 'ellipsis',
                                                                            whiteSpace: 'nowrap', textAlign: 'left',
                                                                        }} title={title}>{title}</div>
                                                                        {item.statusName === '已发布' ?
                                                                            <div style={{
                                                                                height: 22,
                                                                                lineHeight: '22px',
                                                                                marginLeft: 20
                                                                            }}><img src={source}
                                                                                    style={{width: 16, height: 16}}
                                                                                    alt=""/></div> : null} <span
                                                                        style={{
                                                                            color: item.statusName === '已发布' ? '#ffffff' : '#a4adc8',
                                                                            marginLeft: 10
                                                                        }}>{item.statusName}</span>
                                                                    </div>
                                                                </Popover>
                                                            )
                                                        })
                                                    }

                                                    <div style={{clear: 'both'}}/>
                                                    <div style={{height: 20, background: ' #f4f6fc',}}/>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                                {/* <div style={{marginTop: 30}}>
                                    <div><img src={web} alt=""/><span
                                        style={{fontSize: 15, marginLeft: 20}}><b>博达新闻网</b></span></div>
                                    <div style={{background: ' #f4f6fc', borderRadius: 6}}>
                                        <div className={'item'} style={{
                                            border: 'solid 1px ' +this.props.newSecondSelectColor,
                                            float: 'left',
                                            borderRadius: 6,
                                            padding: '12px 20px',
                                            background: '#ffffff',
                                            marginLeft: 20,
                                            marginTop: 20,
                                            fontSize: 15,color:this.props.newSecondSelectColor
                                        }}>清华大学新闻网 <img src="" alt=""/> <span style={{color:'#a4adc8'}}>已发布</span></div>
                                        <div style={{clear: 'both'}}/>
                                      <div style={{height:20,background: ' #f4f6fc',}} />
                                    </div>
                                </div>*/}
                            </Scrollbars>
                        </div>
                    </div>

                </Modal>
            </div>
        )
    }

    getOpenDetail(item) {

        let publishList = [];
        this.actions.getWebsiteStoryPublishUrl({storyId: item.publishId}, data => {
            if (data && data.length > 0) {
                publishList = data;
            }
            if(publishList.length>0){
                item.checked=true;
            }else{
                item.checked=false;
                message.info('没有查询到相关数据')

            }
            this.setState({publishList});
        })
    }

}